import { FC, useState } from 'react';
import classNames from 'classnames';
import { Divider } from 'common-components';
import { useTranslationContext } from '../contexts/translationContext';
import { SearchFiltersProps } from './searchFiltersTypes';
import { KeyboardArrowDownIcon, KeyboardArrowUpIcon, Switch } from '../uiLibraryImports';
import styles from './searchFilters.module.scss';

const SearchFilters: FC<SearchFiltersProps> = (props: SearchFiltersProps) => {
    const {
        languages,
        types,
        progress,
        setAssignedToMe,
        setSelectedFilters,
        assignedToMe,
        selectedFilters,
        setNumberOfFiltersApplied
    } = props;
    const { translate } = useTranslationContext();
    const [currentTab, setCurrentTab] = useState<{ name: string; displayName: string; content: string[] }>();

    const tabs = [
        {
            name: 'language',
            displayName: translate('Language'),
            content: languages
        },
        { name: 'type', displayName: translate('Type'), content: types },
        { name: 'progress', displayName: translate('Progress'), content: progress }
    ];

    const onSelectFilter = (filter: string) => {
        const currentSelectedFilters = [...selectedFilters];
        if (!currentSelectedFilters.includes(filter)) currentSelectedFilters.push(filter);
        else currentSelectedFilters.splice(currentSelectedFilters.indexOf(filter), 1);
        setSelectedFilters(currentSelectedFilters);
        setNumberOfFiltersApplied(currentSelectedFilters.length);
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles['filters-wrapper']}>
                <div className={styles['filter-titles-wrapper']}>
                    {tabs.map((tab, index) => (
                        <>
                            <div
                                key={index}
                                onClick={() => setCurrentTab(prev => (prev?.name === tab.name ? undefined : tab))}
                                className={classNames(styles['filter-title'], {
                                    [styles['selected-filter-type']]: currentTab?.name === tab.name
                                })}
                            >
                                <div>{tab.displayName}</div>
                                {currentTab?.name === tab.name ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </div>
                            {index !== tabs.length - 1 && (
                                <Divider
                                    orientation="vertical"
                                    color="rgba(255, 255, 255, 0.5)"
                                    className={styles.divider}
                                />
                            )}
                        </>
                    ))}
                </div>
                <Divider
                    orientation="horizontal"
                    color="rgba(255, 255, 255, 0.3)"
                    className={styles['horizontal-divider']}
                />
                {currentTab?.content?.length && currentTab.content.length > 0 ? (
                    <div className={styles['tags-wrapper']}>
                        {currentTab.content.map((item, index) => (
                            <div
                                key={index}
                                onClick={() => onSelectFilter(item)}
                                className={classNames(styles.tag, {
                                    [styles['selected-tag']]: selectedFilters.includes(item)
                                })}
                            >
                                {item}
                            </div>
                        ))}
                    </div>
                ) : null}
                {currentTab?.content?.length && currentTab.content.length > 0 ? (
                    <Divider
                        orientation="horizontal"
                        color="rgba(255, 255, 255, 0.3)"
                        className={styles['horizontal-divider']}
                    />
                ) : null}
                <div className={styles['assigned-switch']}>
                    <div>{translate('AssignedToMe')}</div>
                    <Switch checked={assignedToMe} onChange={event => setAssignedToMe(event.target.checked)} />
                </div>
            </div>
        </div>
    );
};

export default SearchFilters;
